import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { createTheme, styled, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { useEffect, useState } from "react";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { MaterialTextFieldComponentModel } from "../../models/components.model";
import { useSelector } from "react-redux";

let mainColor: any;

const StyledInput = styled(TextField)({
  root: {
    ":-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 1000px white inset",
      backgroundColor: "red !important",
    },
  },
  input: {
    ":-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 1000px white inset",
      backgroundColor: "red !important",
    },
  },
  "& label": {
    "&.Mui-focused": {
      color: mainColor,
    },
    "&.Mui-error": {
      color: "#e6123d",
    },
  },
  "& .MuiFormHelperText-root.Mui-error": {
    color: "#e6123d",
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor: mainColor,
    },
    "&.Mui-error fieldset": {
      borderColor: "#e6123d",
    },
  },
  "& .Mui-error": {
    color: "#e6123d",
  },
  "&:-webkit-autofill": {
    WebkitBoxShadow: "0 0 0 100px #E0D98C <<<<(Your color here) inset",
    WebkitTextFillColor: "default",
  },
});

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
// controlId="formBasicEmail"
export default function MaterialTextFieldComponent(
  props: MaterialTextFieldComponentModel
) {
  const jsonFile = useSelector((state: any) => state.style);
  mainColor = jsonFile?.mainColor;

  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <div
          dir={props.text_En == "ENG" ? "ltr" : "rtl"}
          style={{ marginBottom: "0px" }}
        >
          <StyledInput
            className={
              props.error ? "shadowTextFieldError " : "shadowTextField "
            }
            style={{ marginBottom: "0px" }}
            // InputLabelProps={{ style: { fontSize: '12px', fontWeight: 'bold' } }}
            autoFocus={props.autoFocus}
            label={props.label}
            error={props.error}
            onChange={props.onChange}
            helperText={props.helperText}
            form-control
            margin="normal"
            variant="outlined"
            value={props.value}
            type={props.type}
            // InputLabelProps={
            //   jsonFile?.muiColor === "success" ? {} : { style: { top: "-3px" } }
            // }
            multiline={props.multiline}
            rows={props.rows}
            name={props.name}
            id={props.id}
            color={jsonFile?.muiColor}
            onKeyDown={props.onKeyDown}
            onBlur={props.onBlur}
            // onFocus={props.onFocus}
            ref={props.ref}
            onMouseUp={props.onMouseUp}
            onSelect={props.onSelect}
            maxRows={props.maxRows}
            minRows={props.minRows}
            defaultValue={props.defaultValue}
            sx={props.sx}
            disabled={props.disable}
            placeholder={props.placeHolder}
            // inputProps={props.inputProps}
            inputProps={{ ...props.inputProps, onKeyDown: undefined }}
            required={props.required}
            autoComplete={props.autoComplete}
          />
        </div>
      </ThemeProvider>
    </CacheProvider>
  );
}
